<template>
    <div>
        <el-tabs v-model="tab">
            <el-tab-pane :label="$t('store_catalog')" name="catalog">
                <div class="points">Доступно баллов: <img src="../assets/rich.svg" style="height: 18px;"> {{ $n($store.getters.getUser.points) }}</div>
                <el-row :gutter="12">
                    <el-col :span="4" v-for="(item, index) in data" :key="index" style="margin-bottom: 10px">
                        <el-card :body-style="{ padding: '0px' }" shadow="hover">
                            <img src="../assets/cover-blank.png" class="image" :style="{ 'background-image': 'url(' + item.cover + ')', 'background-size': 'cover', 'background-position': '50%' }" @click="order(item)">
                            <div style="padding: 14px;">
                                <span style="white-space: nowrap;">{{ item.name }}</span>
                                <div class="bottom clearfix">
                                    <time class="price"><img src="../assets/rich.svg" style="height: 18px;"> {{ $n(item.price) }}</time>
                                    <el-button type="text" class="button" @click="order(item)">{{ $t('gift_select') }}</el-button>
                                </div>
                            </div>
                        </el-card>
                    </el-col>
                </el-row>
                <div class="pagination">
                    <el-pagination
                            background
                            layout="prev, pager, next"
                            @current-change="handleCurrentChange"
                            :current-page="page"
                            :page-count="total_pages">
                    </el-pagination>
                </div>
            </el-tab-pane>
            <el-tab-pane :label="$t('store_orders')" name="orders">

                <StoreOrderItem ref="orders" />
            </el-tab-pane>
            <!--<el-tab-pane label="Как заработать баллы" name="rule">-->

            <!--</el-tab-pane>-->
        </el-tabs>

        <el-dialog :title="$t('order_gift_title')" :visible.sync="dialogFormVisible">
            <StoreOrder :item="selectedItem" v-on:cancel="dialogFormVisible = false" v-on:update = "orderSuccess" />
        </el-dialog>
    </div>
</template>

<script>
    import qs from 'qs'
    import StoreOrder from "../components/StoreOrder";
    import StoreOrderItem from "../components/StoreOrderItem";
    export default {
        name: "Store",
        components: {StoreOrderItem, StoreOrder},
        data () {
            return {
                tab: 'catalog',
                data: [],
                page: 1,
                total_pages: 0,
                loading: false,
                selectedItem: {},
                dialogFormVisible: false
            };
        },
        created () {
            this.fetchData();
        },
        methods: {
            fetchData () {
                this.loading = true;
                this.$axios.get('/store?' + qs.stringify({ page: this.page, 'per-page': '36', sort: '-price' }, { encode: false })).then((res) => {
                    this.data = res.data;
                    this.total_pages = parseInt(res.headers['x-pagination-page-count']);
                    this.loading = false;
                })
            },
            handleCurrentChange(val) {
                this.page = val;
                this.fetchData()
            },
            order (item) {
                this.dialogFormVisible = true;
                this.selectedItem = item;
            },
            orderSuccess () {
                this.tab = 'orders';
                this.$refs.orders.fetchData();
            }
        }
    }
</script>

<style scoped>
    .price {
        font-size: 13px;
        color: #999;
    }

    .bottom {
        margin-top: 13px;
        line-height: 12px;
    }

    .button {
        padding: 0;
        float: right;
    }

    .image {
        max-width: 100%;
        width: 100%;
        display: block;
    }

    .clearfix:before,
    .clearfix:after {
        display: table;
        content: "";
    }

    .clearfix:after {
        clear: both
    }

    .points {
        margin-bottom: 10px;
        color: #6F7990;
    }
</style>